import axios from "axios";

class msal {
  static async verifyAccessToken(accessToken, judgeHash, dir) {
    let flag = false;

    if (judgeHash && dir == "JudgeDir") {
      try {
        await axios.get("judge/self");
        return true;
      } catch (Exception) {
        return false;
      }
    } else if (accessToken && (dir == "AdminDir" || dir == "InstructorDir")) {
      try {
        await axios.get("account/instructors");
        flag = dir != "InstructorDir";
      } catch (Exception) {
        try {
          await axios.get("projects/round");
          flag = dir != "AdminDir";
        } catch (Exception) {
          return false;
        }
      }
    }

    return flag;
  }

  static async login(msalInstance, store) {
    // Use redirect flow instead of popup to avoid COOP warnings
    store.commit("startLoading");

    try {
      await msalInstance.loginRedirect({
        scopes: ["api://25fab972-96ef-45d0-aaea-ecae30fa2aed/access_as_user"],
      });
      // Note: loginRedirect will navigate away from the page.
      // The redirect response will be handled in main.js when the user returns
    } catch (error) {
      console.error("loginRedirect failed:", error);
      store.commit("stopLoading");
    }
  }

  static async acquireToken(msalInstance, store, account) {
    // Method to acquire token for account after redirect
    try {
      const response = await msalInstance.acquireTokenSilent({
        account,
        scopes: ["api://25fab972-96ef-45d0-aaea-ecae30fa2aed/access_as_user"],
      });
      store.dispatch("setAuth", response);
    } catch (error) {
      console.error("acquireTokenSilent failed:", error);
      // If silent token acquisition fails, redirect to login
      await msalInstance.acquireTokenRedirect({
        account,
        scopes: ["api://25fab972-96ef-45d0-aaea-ecae30fa2aed/access_as_user"],
      });
    }
  }

  static async logout(msalInstance, store) {
    if (store.getters.getAccountType == "Judge") {
      store.dispatch("setAuth", null);
    } else {
      // Use redirect flow for logout to avoid COOP warnings
      try {
        // Get the current account
        const accounts = msalInstance.getAllAccounts();
        const account = accounts.length > 0 ? accounts[0] : null;

        // Clear local state before redirect
        store.dispatch("setAuth", null);

        // Logout and redirect to Microsoft to clear their session
        await msalInstance.logoutRedirect({
          account: account,
          postLogoutRedirectUri: window.location.origin,
        });
      } catch (error) {
        console.error("logoutRedirect failed:", error);
        // Local state already cleared above
      }
    }
  }
}

export default msal;
